module.exports = __webpack_public_path__ + "static/media/46.d86ffd12.jpg";